module.exports = __webpack_public_path__ + "img/Stop.a6e7be88.svg";